import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './decision_upload_header.module.scss';

export const DecisionUploadHeader: FC = () => (
  <>
    <h1 className={styles.title}>
      <FormattedMessage id="upload/decision-upload/components/DecisionUploadHeader.tsx/1" />
    </h1>
    <div className={styles.note}>
      <FormattedMessage id="upload/decision-upload/components/DecisionUploadHeader.tsx/2" />
    </div>
    <div className={styles.note}>
      <FormattedMessage id="upload/decision-upload/components/DecisionUploadHeader.tsx/3" />
    </div>
  </>
);
